// Click-to-translate in replay mode.
//
// Most translations are already baked into the recorded /texts/{id} payloads,
// so the reader rarely calls POST /translation. When it does (an unknown word),
// we answer from a dictionary built by scanning every recorded payload for
// { term, translation } pairs — no network, no API key.

import { allFixtures } from './fixtures';

let dictionary: Map<string, string> | null = null;

function harvest(value: unknown, into: Map<string, string>): void {
  if (Array.isArray(value)) {
    for (const item of value) harvest(item, into);
    return;
  }
  if (value && typeof value === 'object') {
    const obj = value as Record<string, unknown>;
    const term = obj.term ?? obj.word ?? obj.text;
    const translation = obj.translation ?? obj.translatedText;
    if (typeof term === 'string' && typeof translation === 'string' && translation.trim()) {
      const key = term.trim().toLowerCase();
      if (!into.has(key)) into.set(key, translation);
    }
    for (const v of Object.values(obj)) harvest(v, into);
  }
}

function getDictionary(): Map<string, string> {
  if (dictionary) return dictionary;
  dictionary = new Map();
  for (const fixture of allFixtures()) harvest(fixture.body, dictionary);
  return dictionary;
}

export function translateTerm(text: string): string {
  if (!text) return '';
  return getDictionary().get(text.trim().toLowerCase()) ?? '';
}
